import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequirementActionResponse, RequirementApiResponse, RequirementPageResponse } from "../model/requirement.model";
import { RequirementParameterListRequest, RequirementParameterRequest, RequirementParameterResponse } from "../model/requirement-parameter.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffRequirementParametersService {
  private readonly parametersUrl: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.parametersUrl = `${basePath.replace(/\/$/, "")}/api/v1/requirement-parameters`;
  }

  list(request: RequirementParameterListRequest = {}): Observable<RequirementApiResponse<RequirementPageResponse<RequirementParameterResponse>>> {
    let params = new HttpParams();
    if (request.companyId !== undefined) params = params.set("companyId", request.companyId);
    if (request.paramKey) params = params.set("paramKey", request.paramKey);
    if (request.limit !== undefined) params = params.set("limit", request.limit);
    if (request.offset !== undefined) params = params.set("offset", request.offset);
    return this.http.get<RequirementApiResponse<RequirementPageResponse<RequirementParameterResponse>>>(this.parametersUrl, { params });
  }

  get(id: number): Observable<RequirementApiResponse<RequirementParameterResponse>> {
    return this.http.get<RequirementApiResponse<RequirementParameterResponse>>(`${this.parametersUrl}/${id}`);
  }

  getEffective(paramKey: string, companyId?: number): Observable<RequirementApiResponse<RequirementParameterResponse>> {
    const params = companyId === undefined ? new HttpParams() : new HttpParams().set("companyId", companyId);
    return this.http.get<RequirementApiResponse<RequirementParameterResponse>>(`${this.parametersUrl}/effective/${encodeURIComponent(paramKey)}`, { params });
  }

  create(request: RequirementParameterRequest): Observable<RequirementApiResponse<RequirementParameterResponse>> {
    return this.http.post<RequirementApiResponse<RequirementParameterResponse>>(this.parametersUrl, request);
  }

  update(id: number, request: RequirementParameterRequest): Observable<RequirementApiResponse<RequirementParameterResponse>> {
    return this.http.put<RequirementApiResponse<RequirementParameterResponse>>(`${this.parametersUrl}/${id}`, request);
  }

  delete(id: number): Observable<RequirementActionResponse> {
    return this.http.delete<RequirementActionResponse>(`${this.parametersUrl}/${id}`);
  }
}
